import React from 'react';
import { Tag } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';

// Indicador visible sólo cuando el frontend corre apuntando a staging
// (REACT_APP_ENV === "staging", ver configs/FirebaseConfig.js).
const isStaging = (process.env.REACT_APP_ENV || '').trim() === 'staging';

export default function StagingBadge() {
  if (!isStaging) {
    return null;
  }
  return (
    <Tag color="orange" icon={<ExperimentOutlined />} style={{ marginRight: 0, fontWeight: 600 }}>
      STAGING
    </Tag>
  );
}
